/**
 * useSubscriptionUsage Hook
 *
 * Fetches current usage vs limits for dimension-based subscription.
 * Shows products, storage, and channels usage.
 */

import { useQuery } from '@tanstack/react-query';
import { getUsage, type UsageInfo } from '@/lib/api/subscription-pricing';

export function useSubscriptionUsage() {
  return useQuery<UsageInfo>({
    queryKey: ['subscription-usage'],
    queryFn: getUsage,
    retry: 2,
    staleTime: 1000 * 60 * 1, // 1 minute (usage changes frequently)
    refetchInterval: 1000 * 60 * 5,
    refetchIntervalInBackground: false,
  });
}
